module.exports = __webpack_public_path__ + "269bfc2d790b7662c311289ec6259422.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_3_b.png
// module id = 73
// module chunks = 0